import script from "./breadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&setup=true&lang=js"

import "./breadcrumbs.vue?vue&type=style&index=0&id=ece04edc&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ece04edc"]])

export default __exports__